var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-4"},[_c('h2',[_vm._v("About This App")]),_c('p',[_vm._v("App to search Github users")]),_c('p',[_vm._v("Version 1.0.0")])])
}]

export { render, staticRenderFns }